import { Factory } from 'miragejs'

export default Factory.extend({
  name: 'Vision Nursery',
  locationId: 123,
  location: 'Wembley / Main Building / Food'
})

// Example full payload

// {
//   "id": 21,
//   "locationId": 19,
//   "location": "Wembley / Main Building / Food"
//   "name": "Vision Nursery",
//   "created": "2018-08-16T11:35:02.95201Z",
//   "updated": "2018-08-16T11:35:02.95201Z"
// }
